/*
 * Copyright (c) 2021. Manchester Economic Forecasting Limited <http://mef-uk.com>
 */

import React from 'react';
import { CircularProgress, createStyles, makeStyles } from '@material-ui/core';
import Layout from './Layout';

const useStyles = makeStyles(() =>
	createStyles({
		container: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
	})
);

const LoadingScreen = (): JSX.Element => {
	const styles = useStyles();
	return (
		<Layout>
			<div className={styles.container}>
				<CircularProgress data-testid="loading" size={100} />
			</div>
		</Layout>
	);
};

export default LoadingScreen;
